import LayoutV2 from 'components/LayoutV2';
import useBreakpoint from 'hooks/useBreakpoint';

import JobContent from './Content';
import MobileButtons from './components/MobileButtons';
import ProgressHeaderIndicator from './components/ProgressHeaderIndicator';
import ProgressSidebar from './components/ProgressSidebar';
import JobProvider from './context';

const Job: React.FunctionComponent = function () {
  const underBreakpoint = useBreakpoint(1024);
  return (
    <JobProvider>
      <LayoutV2
        sidePanel={underBreakpoint ? null : <ProgressSidebar />}
        header={<ProgressHeaderIndicator />}
        footer={<MobileButtons />}
      >
        <JobContent />
      </LayoutV2>
    </JobProvider>
  );
};

export default Job;
